import { useLanguageContext } from "../../../../Components/Languages/Langs/LanguageContext";

export const ListLangs = () => {
  const { t } = useLanguageContext();

  return {
    EN: t("translateSwicherLang.en"),
    PL: t("translateSwicherLang.pl"),
    ES: t("translateSwicherLang.es"),
    UA: t("translateSwicherLang.ua"),
    FR: t("translateSwicherLang.fr"),
    UZ: t("translateSwicherLang.uz"),
    JA: t("translateSwicherLang.ja"),
  };
};
